/** @format */

import React from "react";
import { useRef } from "react";
import { Row, Col } from "react-bootstrap";
// import applelogin from "../../../Assets/img/apple-logo.png";
import facebooklogin from "../../../Assets/img/facebook-logo.png";
import googlelogin from "../../../Assets/img/google.png";
import {
  openViewForgotPassword,
  openModal,
  openRegisterForm,
} from "../../../Features/ViewSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { LoginSocialGoogle, LoginSocialFacebook } from "reactjs-social-login";
import Loader from "../Loader/Loader";
import { closeModal } from "../../../Features/ViewSlice";
import { useNavigate } from "react-router";
import { loginWithSocial, loadingStart } from "../../../Features/AuthSlice";
const AgencyLoginForm = ({ handleSubmit, handleChange }) => {
  // const REDIRECT_URI = "https://localhost:3000";
  const REDIRECT_URI = "https://lkwb.com.np/dashboard";
  let inputPassword = useRef(null);
  let navigate = useNavigate();
  let dispatch = useDispatch();
  let isLoading = useSelector((state) => state.auth.isLoading);
  const togglePasswordShow = () => {
    inputPassword.current.getAttribute("type") === "password" ?
      inputPassword.current.setAttribute("type", "text")
      : inputPassword.current.setAttribute("type", "password");
  };
  return (
    <>
      {!isLoading ?
        <form className="AgencyloginForm">
          <h2>Sign In</h2>
          <p className="mb-3">We help you to learn korean language with ease.</p>
          <label htmlFor="email">
            <input
              name="email"
              type="text"
              placeholder="Enter your email or username"
              onChange={handleChange}
            ></input>
          </label>
          <label htmlFor="password" className="password-container">
            <input
              ref={inputPassword}
              name="password"
              placeholder="Enter your password"
              type="password"
              onChange={handleChange}
            ></input>
            <i className="bi bi-eye-slash" onClick={togglePasswordShow}></i>
          </label>
          <div className="formoptions ">
           
          </div>
          <button
            onClick={(e) => {
              handleSubmit(e);
            }}
          >
            Sign In
          </button>
        </form>
        : <div className="loading__mode bigloading">
          <Loader label="Redirecting you to dashboard! Please wait" />
        </div>
      }
    </>
  );
};

export default AgencyLoginForm;
